// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"4955dc84","58":"37788586","171":"3b632380","422":"255ab173","769":"4804c3cd","801":"1780535b","929":"cafa449e"}[chunkId] + ".chunk.js";
};